import useSWRMutation from 'swr/mutation';

import { fetcher } from '@/data/fetcher';
import { ExportAnnotationQueueRunsRequest } from '@/types/schema';
import { apiAnnotationQueuesPath } from '@/utils/constants.tsx';

export function useDownloadQueueRuns(queueId?: string, tenantId?: string) {
  return useSWRMutation(
    queueId ? [`${apiAnnotationQueuesPath}/${queueId}/export`, tenantId] : null,
    async (
      [url],
      { arg }: { arg: { start_time?: string; end_time?: string } }
    ) => {
      const res = await fetcher<
        Response,
        never,
        ExportAnnotationQueueRunsRequest
      >({
        url,
        method: 'POST',
        resolveWithResponse: true,
        headers: { 'X-Tenant-Id': tenantId! },
        json: {
          start_time: arg.start_time,
          end_time: arg.end_time,
        },
      });

      if (!res.ok) {
        let message = '';
        try {
          const body = await res.json();
          message = body?.detail || body?.message || '';
        } catch (e) {
          message = res.statusText;
        }
        throw new Error(`Error fetching queue: ${message}`);
      }

      const headers = res.headers;
      const blob = await res.blob();

      const downloadUrl = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = downloadUrl;
      a.download =
        headers.get('Content-Disposition')?.split('=')[1] ||
        `annotation_queue.csv`;
      a.click();
      URL.revokeObjectURL(downloadUrl);
    }
  );
}
